<template>
    <div>
        <div class="content-box mr60">
            <el-form ref="form" label-width="120px" :model="formItem" :rules="rules" class="form-wrap">
                <el-form-item label="工单驳回：" prop="rejected_reason">
                    <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 5 }" placeholder="请输入工单驳回的理由，20字之内" v-model.trim="formItem.rejected_reason" clearable maxlength="20" show-word-limit></el-input>
                </el-form-item>
            </el-form>
        </div>
        <p class="dialog-footer tac mt20">
            <el-button type="default" @click="hideModal" class="action-btn mr20">取消</el-button>
            <el-button type="primary" @click="submitModal" :loading="formLoading" class="action-btn ml20">提交</el-button>
        </p>
    </div>
</template>

<!-- 工单管理 待指派 驳回弹框-->
<script>
    import API from '@/api/workOrder/material.js';
    import matomoFun from "@/utils/matomo.js";
    import { find } from 'lodash';
    export default {
        name: "order_withdrawModal",
        props:['cbs', 'id','name','desc'],
        data(){
            return {
                formLoading:false,
                formItem:{
                    rejected_reason:'',
                },
                rules:{
                    rejected_reason: [
                        { required: true, message: '请输入驳回的原因，20字之内', trigger: 'blur' },
                        { min: 1, max: 20, message: '请输入驳回的原因，20字之内', trigger: 'blur' }
                    ],
                },
            }
        },
        mounted(){
        },
        methods:{
            pushMatomo(name) {
                matomoFun.trackEvent(this.name, '点击', name)
            },
            submitModal(){
                this.$refs.form.validate((valid) => {
                    if (valid) {
                        this.pushMatomo(`${this.desc}提交)`)
                        this.fetchAssignOrderDelete(this.id)
                    } else {
                        return false;
                    }
                });
            },
            hideModal(){
                // this.pushMatomo(`${this.desc}取消)`)
                this.$emit('close');
            },
            fetchAssignOrderDelete(id) {
                this.formLoading = true;
                API.postAssignOrderReject({order_id:id,rejected_reason:this.formItem.rejected_reason}).then(res=>{
                    this.$message.success(res.info)
                    this.cbs.onSubmit();
                    this.formLoading = false;
                    this.hideModal();
                },err=>{
                    this.$message.error(err.info)
                    this.formLoading = false;
                }).finally(()=>{
                    this.formLoading = false;
                })
            },
        }
    }
</script>

<style scoped>

</style>
